import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {
    InstalacaoProduto,
    ParametroInstalacaoProduto,
    ParametroConteudoInstalacaoProduto,
    Cliente
} from '../../../model/catalogo';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';

import {ActivatedRoute} from '@angular/router';
import {CatalogoApiService} from '../../../service/api/catalogo.api';

@Component({
    selector: 'instalacao-produto-modal',
    templateUrl: './instalacao-produto-modal.component.html',
    styleUrls: ['./instalacao-produto-modal.component.css']
})
export class InstalacaoProdutoModalComponent {

    constructor(
        private globalService: GlobalService,
        public modalService: ModalService,
        public pesquisaService: PesquisasFiltroApiService,
        public catalogoApi: CatalogoApiService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute) {
    }

    private sub: any;

    pagina: number = 1;
    qtdPorPagina: number = 7;
    totalPaginas: number = 1;

    paginaNaoVinculada: number = 1;
    qtdPorPaginaNaoVinculada: number = 7;
    totalPaginasNaoVinculada: number = 1;

    campoBusca = new FormControl('', []);

    nomeNovaInstalacao = new FormControl('', []);
    enderecoConexao = new FormControl('', []);
    portaConexao = new FormControl('', []);
    oid = new FormControl('', []);
    credit = new FormControl('', []);

    selecionaAutomatico: boolean = false;
    cadastraNovaInstalacao: boolean = false;

    resultado: Array<InstalacaoProduto> = null;
    visiveis: Array<InstalacaoProduto> = null;

    resultadoNaoVinculada: Array<InstalacaoProduto> = null;
    visiveisNaoVinculada: Array<InstalacaoProduto> = null;


    selecionado: InstalacaoProduto = null;
    selecionadoNaoVinculado: InstalacaoProduto = null;

    cliente: Cliente = null;
    nomeItemConfiguracao: string = '';
    mensagemErro: string = '';
    mensagemErroNaoVinculada: string = '';

    instalacaoModalForm: FormGroup = this.formBuilder.group({
        campoBusca: this.campoBusca,
    });

    novaInstalacaoModalForm: FormGroup = this.formBuilder.group({
        enderecoConexao: this.enderecoConexao,
        portaConexao: this.portaConexao,
        oid: this.oid,
        credit: this.credit
    });

    ngOnInit() {
        this.mensagemErro = '';
        this.mensagemErroNaoVinculada = '';
        this.campoBusca.setValue('');
        this.selecionaAutomatico = false;
        this.cadastraNovaInstalacao = false;
        this.cliente = null;

        this.sub = this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                if (params['campoBusca'] != '') {
                    this.campoBusca.setValue(params['campoBusca']);
                }
                if (params['selecionaAutomatico'] != '') {
                    this.selecionaAutomatico = params['selecionaAutomatico'];
                }
                if (params['cadastraNovaInstalacao'] != '') {
                    this.cadastraNovaInstalacao = params['cadastraNovaInstalacao'];
                }
                if (params['nomeItemConfiguracao'] != '') {
                    this.nomeItemConfiguracao = params['nomeItemConfiguracao'];
                }
                if (params['codInstalacao'] == 0) {
                    this.enderecoConexao.setValue(params['comm_address']);
                    this.portaConexao.setValue(params['comm_port']);
                    this.oid.setValue(params['oid']);
                    this.credit.setValue(params['credit']);
                }
                if (params['cliente'] != undefined) {
                    this.cliente = JSON.parse(params['cliente']);
                }
                this.pesquisar();
            });
    }

    pesquisar() {
        let filtros: Array<any> = new Array<any>();
        this.visiveis = new Array<InstalacaoProduto>();
        this.resultado = new Array<InstalacaoProduto>();
        this.totalPaginas = 1;

        filtros.push({
            'filtroInstalacaoProduto': {
                'nomeInstalacao': this.campoBusca.value,
                'nomeItemConfiguracaoProduto': this.nomeItemConfiguracao,
                'clienteVinculado': this.cliente,
                'codTipoEstado': 4
            }
        });
        this.pesquisaService.filtraInstalacaoProduto(filtros)
            .subscribe(
                listaInstalacoes => {
                    this.resultado = listaInstalacoes as Array<InstalacaoProduto>;
                    this.mudarPagina(1, 'false');
                    this.totalPaginas = Math.ceil(listaInstalacoes.length / this.qtdPorPagina);
                    // if (this.selecionaAutomatico && this.resultado.length == 1) {
                    //     this.selecionaInstalacao(this.resultado[0]);
                    //     this.confirmar();
                    // }
                    this.pesquisarNaoVinculadas();
                },
                erro => {
                    if (erro.status == 404) {
                        this.pesquisarNaoVinculadas();
                    }
                }
            );
    }

    pesquisarNaoVinculadas() {
        let filtros: Array<any> = new Array<any>();
        this.visiveisNaoVinculada = new Array<InstalacaoProduto>();
        this.resultadoNaoVinculada = new Array<InstalacaoProduto>();
        this.totalPaginasNaoVinculada = 1;

        filtros.push({
            'filtroInstalacaoProduto': {
                'nomeInstalacao': this.campoBusca.value,
                'nomeItemConfiguracaoProduto': this.nomeItemConfiguracao,
                'codTipoEstado': 4
            }
        });
        this.pesquisaService.filtraInstalacaoProduto(filtros)
            .subscribe(
                listaInstalacoes => {
                    this.resultado.forEach(elementoVinculado => {
                        listaInstalacoes.forEach((elemento, index) => {
                            if (elementoVinculado.nomeInstalacao == elemento.nomeInstalacao) {
                                listaInstalacoes.splice(index, 1);
                            }
                        });
                    });
                    this.resultadoNaoVinculada = listaInstalacoes;
                    this.mudarPaginaNaoVinculada(1, 'false');
                    this.totalPaginasNaoVinculada = Math.ceil(listaInstalacoes.length / this.qtdPorPaginaNaoVinculada);
                },
                erro => {
                    if (erro.status == 404) {
                    }
                }
            );
    }

    selecionaInstalacao(instalacao: InstalacaoProduto) {
        this.selecionado = instalacao as InstalacaoProduto;
    }

    selecionaInstalacaoNaoVinculada(instalacao: InstalacaoProduto) {
        this.selecionadoNaoVinculado = instalacao as InstalacaoProduto;
    }

    parametroInstalacao(parmNome: string, conteudo: string): ParametroInstalacaoProduto {
        let parmInstalacao: ParametroInstalacaoProduto = new ParametroInstalacaoProduto();
        let parmConteudo: ParametroConteudoInstalacaoProduto = new ParametroConteudoInstalacaoProduto();
        parmInstalacao.parmConteudo = new Array<ParametroConteudoInstalacaoProduto>();
        parmInstalacao.parmNome = parmNome;
        parmConteudo.nrPosicao = 0;
        parmConteudo.conteudo = conteudo;
        parmInstalacao.parmConteudo.push(parmConteudo);
        return parmInstalacao;
    }

    novaInstalacao() {
        if (this.campoBusca.value == '' || this.enderecoConexao.value == '' || this.portaConexao.value == '') {
            this.mensagemErro = 'Para solicitar o cadastro de uma nova instalação de produto, é necessário preencher todos os campos.';
            return false;
        }
        if (this.nomeItemConfiguracao == 'RVS' && (this.oid.value == '' || this.credit.value == '')) {
            this.mensagemErro = 'Para solicitar o cadastro de uma nova instalação de produto, é necessário preencher todos os campos.';
            return false;
        }
        this.selecionado = new InstalacaoProduto();
        this.selecionado.codigo = 0;
        this.selecionado.nomeInstalacao = this.campoBusca.value;
        this.selecionado.nomeItemConfiguracaoProduto = this.nomeItemConfiguracao;
        this.selecionado.parmInstalacaoProduto = new Array<ParametroInstalacaoProduto>();
        if (this.enderecoConexao.value) {
            this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('comm_address', this.enderecoConexao.value));
        }
        if (this.portaConexao.value != '') {
            this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('comm_port', this.portaConexao.value));
        }
        if (this.oid.value != '') {
            this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('oid', this.oid.value));
        }
        if (this.credit.value != '') {
            this.selecionado.parmInstalacaoProduto.push(this.parametroInstalacao('credit', this.credit.value));
        }
        this.confirmar();
    }

    mudarPagina(pag: number, desabilitado: string) {

        if (desabilitado == 'true') {
            return false;
        }

        this.pagina = pag;
        this.visiveis = new Array<InstalacaoProduto>();
        let ind = 1;
        this.resultado.forEach(res => {
            if (ind > (pag - 1) * this.qtdPorPagina && ind <= pag * this.qtdPorPagina) {
                this.visiveis.push(res);
            }
            ind++;
        });
    }

    mudarPaginaNaoVinculada(pag: number, desabilitado: string) {

        if (desabilitado == 'true') {
            return false;
        }

        this.paginaNaoVinculada = pag;
        this.visiveisNaoVinculada = new Array<InstalacaoProduto>();
        let ind = 1;
        this.resultadoNaoVinculada.forEach(res => {
            if (ind > (pag - 1) * this.qtdPorPaginaNaoVinculada && ind <= pag * this.qtdPorPaginaNaoVinculada) {
                this.visiveisNaoVinculada.push(res);
            }
            ind++;
        });
    }

    confirmar() {
        if (this.selecionado == null) {
            this.mensagemErro = 'Selecione a Instalação de Produto ou clique em \'Fechar\'';
        } else {
            this.modalService.incluirDadosGerados(this.selecionado);
            this.modalService.fecharPaginaModal();
        }
    }

    cancelar() {
        this.modalService.fecharPaginaModal();
    }

    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }

    vincularInstalacaoProduto(): void {
        if (this.selecionadoNaoVinculado == null) {
            this.mensagemErroNaoVinculada = 'Selecione a Instalação de Produto para realizar a vinculação';
        } else {
            this.mensagemErroNaoVinculada = '';
            this.globalService.loading = true;
            this.catalogoApi.vinculacaoClienteInstalacaoProduto(this.selecionadoNaoVinculado.codigo
                , this.selecionadoNaoVinculado.versao, this.cliente)
                .subscribe(
                    resultado => {
                        this.globalService.loading = false;
                        this.pesquisar();
                    },
                    erro => {
                        this.modalService.exibirMensagem('Erro', 'Erro ao vincular Cliente.', 'Fechar');
                    }
                );
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modal/instalacao-produto-modal/instalacao-produto-modal.component.ts